import { render } from 'mustache';
import fn from '../lib/fn';

window.FINN = window.FINN || {};
window.FINN.travel = FINN.travel || {};
window.FINN.travel.lang = FINN.travel.lang || {};

export function add(key, text) {
    if (arguments.length === 1 && typeof key !== 'string') {
        const texts = key;
        fn.keys(texts).forEach((textKey) => {
            FINN.travel.lang[textKey] = (data) => render(texts[textKey], data);
        });
    } else {
        FINN.travel.lang[key] = (data) => render(text, data);
    }
}

add({
    /* eslint-disable camelcase */
    show_filter: 'Vis filter',
    hide_filter: 'Skjul filter',

    // sorting
    avreise: 'Avreisedato (tidlig - sen)',
    pris_lms: 'Pris per person',
    best: 'Beste treff',
    rating: 'Hotellstandard',

    // filters
    unspecified_lodging: 'Uspesifisert bosted',
    specified_lodging: 'Spesifisert bosted',
    flight_only: 'Kun fly - tur/retur',
    one_way_flight: 'Kun fly - en vei',
    missing_time: 'tidspunkt ikke fastsatt',

    // save search
    save_search_failure: 'Det skjedde en feil og søket ble ikke lagret. Prøv igjen!',
    save_search_success: 'Søket er lagret!',
    /* eslint-enable camelcase */
});
